import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Inscription, useResponsive } from '@common-fe/common-fe';

import ClaimWarningCard from '@/modules/UseMyMoney/widgets/UseMyMoneySummary/components/ClaimWarningCard/ClaimWarningCard';

interface Props {
  onUpload: () => void;
}

const DocumentMayBeRequiredWarning: React.FC<Props> = ({ onUpload }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <ClaimWarningCard
      testId="document-skipped-warning"
      title={t('Document may be required')}
      description={
        <Box gap="spacing2">
          <Inscription color="textBody" lineHeight="20px">
            {t(
              'Depending on the date and type of service, your plan may require supporting documentation to approve this expense.'
            )}
          </Inscription>
          <Inscription color="textBody" lineHeight="20px">
            {t(
              "To receive your money faster, add your documentation now. If you don't have it available, you can always add it later."
            )}
          </Inscription>
        </Box>
      }
      actions={[
        {
          label: t('Upload Document'),
          testId: 'document-skipped-warning_upload',
          onClick: onUpload,
          isFlexible: isMobile,
        },
      ]}
    />
  );
};

export default DocumentMayBeRequiredWarning;
